module.exports = __webpack_public_path__ + "img/carLogo.c7a48e9a.png";